export default __webpack_public_path__ + "static/media/porcentajesUtilidadesIcon.f8cbf708.svg";